import axios from 'axios';

export const homeService = {
    getEventsService: (params) => axios.get(`/events/upcoming/events`, { params: { ...params} }),

    getOrgService: (params) => axios.get('/orgs', { params: { ...params } }),
};
